const pages = ["settings", "Game Rules", "History"]

export const usePages = (enableLoading: boolean) => {
  return enableLoading ? pages : []
}
